import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#000080',//'#3f51b5',colors.purple,
                secondary: '#f5f5dc',//colors.grey.darken1,
                accent: '#8c9eff',//colors.shades.black,
                error: '#b71c1c'//colors.red.accent3,
            },
            dark: {
                primary: colors.blue.lighten3,
            },
        },
    },
});
